import Vue from 'vue'
import { setPropByPath } from '@/helpers/utils'

export default {
  /**
   * Установка данных в источник данных (левая панель)
   * @param {*} state
   * @param {*} param1
   */
  setDataSourceObjects(state, { dataSourceId, dataSourceObjects }) {
    if (state.dataSourceObjects[dataSourceId]) {
      state.dataSourceObjects[dataSourceId] = dataSourceObjects
    } else {
      Vue.set(state.dataSourceObjects, dataSourceId, dataSourceObjects)
    }
  },

  /**
   * Добавление или изменение объекта в источнике данных левой панели
   * @param {*} state
   * @param {*} param1
   */
  updateDataSourceObject(state, { dataSourceId, objectId, objectData }) {
    if (!state.dataSourceObjects[dataSourceId]) {
      Vue.set(state.dataSourceObjects, dataSourceId, {})
    }

    if (!state.dataSourceObjects[dataSourceId][objectId]) {
      Vue.set(state.dataSourceObjects[dataSourceId], objectId, objectData)
    } else {
      state.dataSourceObjects[dataSourceId][objectId] = objectData
    }
  },

  /**
   * Очистка информации источника данных левой панели
   * @param {*} state
   * @param {*} param1
   */
  clearDataSourceObjects(state, { dataSourceId }) {
    if (state.dataSourceObjects[dataSourceId]) {
      state.dataSourceObjects[dataSourceId] = {}
    }
  },

  setObjectLayerSettingsItem(state, { layerSettings }) {
    //Vue.set(state.objectLayerSettings, layerSettings.id, layerSettings)
    state.objectLayerSettings = {
      ...state.objectLayerSettings,
      [layerSettings.id]: layerSettings
    }
  },

  deleteObjectLayerSettingsItem(state, { layerId }) {
    Vue.delete(state.objectLayerSettings, layerId)
  },

  /**
   * Полный сброс словаря с объектами слоя
   * нужен при переключении рабочих пространств
   * @param {*} state
   */
  clearLayerObjects(state) {
    state.layerObjects = {}
  },

  /**
   * Инициализация словаря с объектами слоя
   * @param {*} state
   * @param {*} param1
   */
  initLayerObjects(state, { layerId }) {
    Vue.set(state.layerObjects, layerId, {
      objects: {},
      count: 0
    })
  },

  deleteLayerObjects(state, { layerId }) {
    Vue.delete(state.layerObjects, layerId)
  },

  /**
   * Установка словаря с объектами слоя
   * @param {*} state
   * @param {*} param1
   */
  setLayerObjects(state, { layerId, layerObjects }) {
    state.layerObjects[layerId].objects = layerObjects
  },

  /**
   * Добавление или изменение объектов в словаре объектов слоя
   * @param {*} state
   * @param {*} payload
   * @param [{*}] payload.layerObjectsArray Массив с объектами,
   * которые надо добавить или обновить в словаре объектов слоя
   */
  updateLayerObjects(state, { layerId, layerObjectsArray }) {
    if (!state.layerObjects[layerId] || !state.layerObjects[layerId].objects) {
      return
    }

    layerObjectsArray.forEach((layerObjectsItem) => {
      Vue.set(state.layerObjects[layerId].objects, layerObjectsItem.id, layerObjectsItem)
    })
  },

  /**
   * Обновление данных объекта по идентификатору в словаре объектов слоя
   * @param {*} state
   * @param {*} param1
   */
  updateLayerObjectById(state, { layerId, objectId, objectData }) {
    if (!state.layerObjects[layerId] || !state.layerObjects[layerId].objects || !state.layerObjects[layerId].objects[objectId]) {
      return
    }

    state.layerObjects[layerId].objects[objectId] = objectData
  },

  /**
   * Установка общего количества объектов слоя
   * @param {*} state
   * @param {*} param1
   */
  setLayerObjectsCount(state, { layerId, count }) {
    if (state.layerObjects[layerId]) {
      state.layerObjects[layerId].count = count
    }
  },

  /**
   * Установка видимости слоя
   * @param {*} state
   * @param {*} param1
   * @returns
   */
  setLayerVisibility(state, { layerId, visibility, visibilityProperty = 'visibility' }) {
    let layerSettings = state.objectLayerSettings[layerId]
    if (!layerSettings) {
      return
    }

    layerSettings[visibilityProperty] = visibility
  },

  /**
   * Установка значения order для слоя, которое отвечает за сортровку слоев
   * @param {*} state
   * @param {*} param1
   * @returns
   */
  setLayerOrder(state, { layerId, order }) {
    let layerSettings = state.objectLayerSettings[layerId]
    if (!layerSettings) {
      return
    }

    layerSettings.order = order
  },

  /**
   * Установка visibility для объекта слоя
   * @param {*} state
   * @param {*} param1
   * @returns
   */
  setLayerObjectVisibility(state, { layerId, objectId, visibility }) {
    let layerObjects = state.layerObjects[layerId]
    if (!layerObjects || !layerObjects.objects) {
      return
    }
    // если объекта нет, создаем его (это может быть с маршрутами, маршрут выбрали из карты, выключаем ему видимость, а в панели он еще не подгружен)
    if (!layerObjects.objects[objectId]) {
      // так себе решение, я бы setLayerObjectVisibility в action внесла, т.к. тут поялвяется логика
      Vue.set(state.layerObjects[layerId].objects, objectId, {
        id: objectId,
        isNotFull: true // флаг, что объект неполный, при подгрузке его не учитывать
      })
    }

    Vue.set(layerObjects.objects[objectId], 'visibility', visibility)
  },

  setDataSourceObjectVisibility(state, { dataSourceObject, visibilityProperty = 'visibility', visibility }) {
    //Допустимо ли передавать в мутацию ссылку на объект из vuex, чтобы не искать его в state?
    dataSourceObject[visibilityProperty] = visibility
  },

  /**
   * Установка видимости ВСЕХ объектов слоя
   * @param {*} state
   * @param {*} param1
   * @returns
   */
  setAllLayerObjectsVisibility(state, { layerId, visibility, visibilityProperty = 'visibility' }) {
    let layerObjects = state.layerObjects[layerId]

    if (!layerObjects || !layerObjects.objects) {
      return
    }

    Object.values(layerObjects.objects).forEach((layerObjectsItem) => {
      layerObjectsItem[visibilityProperty] = visibility
    })
  },

  /**
   * Показать или скрыть маршрут для выбранного объекта линейного информационного слоя
   * @param {*} state
   * @param {*} value
   */
  setShowRouteForSelectedStreaminfoObject(state, value) {
    state.showRouteForSelectedStreaminfoObject = value
  },

  /**
   * Показать маршрут для выбранной кп (храним id кп)
   * @param {*} state
   * @param {*} value
   */
  setShowRouteForСontainerPlatform(state, value) {
    state.showRouteForContainerPlatform = value
  },

  /**
   * Установка значения поля в настройках слоя
   * @param {*} state
   * @param {*} param1
   */
  setLayerSettingsField(state, { layerId, fieldName, fieldValue }) {
    if (!state.objectLayerSettings || !state.objectLayerSettings[layerId]) {
      return
    }

    state.objectLayerSettings[layerId][fieldName] = fieldValue
  },

  /**
   * Установка поля для объекта слоя для левой панели
   * @param {*} state
   * @param {*} param1
   * @returns
   */
  setLayerObjectField(state, { layerId, objectId, fieldName, fieldValue }) {
    const layerObjects = state.layerObjects[layerId]
    if (!layerObjects) {
      return
    }

    let layerObjectsItem = layerObjects.objects[objectId]
    if (!layerObjectsItem) {
      return
    }

    setPropByPath(layerObjectsItem, fieldName, fieldValue)
  },

  updateLayerSettings(state, { layerId, ...updatedLayerSettings }) {
    let layerSettings = state.objectLayerSettings[layerId]
    if (!layerSettings) {
      return
    }

    for (let key in updatedLayerSettings) {
      Vue.set(layerSettings, key, updatedLayerSettings[key])
    }
  },

  removeObjectLayerSetting(state, layerId) {
    Vue.delete(state.objectLayerSettings, layerId)
    Vue.delete(state.layerObjects, layerId)
  },

  setLayerStyles(state, { layerStyles }) {
    state.layerStyles = layerStyles
  },

  updateLayerStyle(state, { styleId, styleConfig }) {
    Vue.set(state.layerStyles, styleId, styleConfig)
  },

  setInfoLayerIcons(state, { icons }) {
    state.infoLayerIcons = icons
  },

  addInfoLayerIcon(state, { iconConfig }) {
    state.infoLayerIcons.push(iconConfig)
  },

  setColoringLayerNames(state, { coloringLayerNames }) {
    state.coloringLayerNames = coloringLayerNames
  },

  setColorings(state, { colorings }) {
    state.colorings = colorings
  },

  setLayerColorings(state, { layerColorings }) {
    state.layerColorings = layerColorings
  },

  setLayerColoringConnections(state, { layerColoringConnections }) {
    state.layerColoringConnections = layerColoringConnections
  },

  toggleColoringConnection(state, { coloringId, layerColoringType }) {
    if (!state.layerColoringConnections[coloringId]) {
      return
    }
    state.layerColoringConnections[coloringId][layerColoringType] = !state.layerColoringConnections[coloringId][layerColoringType]
  },

  setRawSelectedObjectInfo(state, { rawSelectedObjectInfo }) {
    state.rawSelectedObjectInfo = rawSelectedObjectInfo
  },

  clearMapMethodsQueue(state) {
    state.mapMethodsQueue = []
  },

  addMapMethodToQueue(state, payload) {
    state.mapMethodsQueue.push(payload)
  },

  setLayerFilterText(state, { layerFilterText }) {
    state.layerFilterText = layerFilterText
  },

  setOpenedBySearchLayerIds(state, { openedBySearchLayerIds }) {
    state.openedBySearchLayerIds = openedBySearchLayerIds
  },

  openLayerBySearch(state, { layerId }) {
    if (!state.openedBySearchLayerIds.includes(layerId)) {
      state.openedBySearchLayerIds.push(layerId)
    }
  },

  closeLayerBySearch(state, { layerId }) {
    state.openedBySearchLayerIds = state.openedBySearchLayerIds.filter((openedLayerId) => {
      return openedLayerId !== layerId
    })
  },

  setObjectFiltersText(state, { text }) {
    if (!state.objectFilters) {
      return
    }
    state.objectFilters.text = text
  }
}



// WEBPACK FOOTER //
// ./src/store/objects/mutationsNewStructure.js